import { colors } from "#app/theme/v2/colors";
import { spacing } from "#app/theme/v2/spacing";

type StepProps = {
  active?: boolean;
};

export const STEP_HEIGHT = spacing[2];

export const Step = ({ active = false }: StepProps) => (
  <div
    style={{
      width: STEP_HEIGHT,
      height: STEP_HEIGHT,
      borderRadius: STEP_HEIGHT,
      backgroundColor: active ? colors.text.secondaryDefault : colors.border.tertiary,
    }}
  />
);
